export const getHTMLAttributes = (props: any) => {
	const dataProps: any = { ...props };
	const dataAria: any = { ...props };
	const rest: any = { ...props };

	Object.keys(dataProps).forEach(function(key, _index) {
		if (!key.startsWith('data-')) {
			delete dataProps[key];
		} else {
			delete rest[key];
		}
	});

	Object.keys(dataAria).forEach(function(key, _index) {
		if (!key.startsWith('aria-')) {
			delete dataAria[key];
		} else {
			delete rest[key];
		}
	});

	return {
		dataProps: dataProps,
		ariaProps: dataAria,
		rest: rest,
	};
};
